{
  "startsWith": "Beginnt mit",
  "contains": "Enthält",
  "notContains": "Enthält nicht",
  "endsWith": "Endet mit",
  "equals": "Ist gleich",
  "notEquals": "Ist nicht gleich",
  "noFilter": "Kein Filter",
  "lt": "Kleiner als",
  "lte": "Kleiner gleich",
  "gt": "Größer als",
  "gte": "Größer gleich",
  "is": "Ist",
  "isNot": "Ist nicht",
  "before": "Vor",
  "after": "Nach",
  "clear": "Leeren",
  "apply": "Anwenden",
  "matchAll": "Match All",
  "matchAny": "Match Any",
  "addRule": "Regel hinzufügen",
  "removeRule": "Regel löschen",
  "accept": "Ja",
  "reject": "Nein",
  "choose": "Auswählen",
  "upload": "Hochladen",
  "cancel": "Abbrechen",
  "dayNames": [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ],
  "dayNamesShort": [
    "Son",
    "Mon",
    "Die",
    "Mit",
    "Don",
    "Fre",
    "Sam"
  ],
  "dayNamesMin": [
    "So",
    "Mo",
    "Di",
    "Mi",
    "Do",
    "Fr",
    "Sa"
  ],
  "monthNames": [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ],
  "monthNamesShort": [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  "today": "Heute",
  "weekHeader": "KW",
  "weak": "Schwach",
  "medium": "Mittel",
  "strong": "Stark",
  "passwordPrompt": "Passwort eingeben",
  "emptyMessage": "Keine Ergebnisse gefunden",
  "emptyFilterMessage": "Keine Ergebnisse gefunden"
}
